module.exports = __webpack_public_path__ + "static/Scott_Ringwelski-d6e501925983ac4ae67d3a9ca778f6ff.png";